import { getPreloaderFnContext, query } from '@confluence/query-preloader-tools';
import { fg } from '@confluence/feature-gating';

import { TopNavigationQuery } from './TopNavigationQuery.graphql';
import { preloadUnseenNotificationCount } from './preloadNotificationCount';

export async function preloadTopNavigation() {
	const { userId } = await getPreloaderFnContext();

	const topNavigationPromises = [
		query({
			query: TopNavigationQuery,
			variables: {
				includeNav4AdminOptIn: fg('confluence_nav4_ga_phase_1'),
			},
		}),
	];

	if (userId && fg('confluence_frontend_preload_notifications')) {
		//skip for anon
		topNavigationPromises.push(preloadUnseenNotificationCount());
	}

	return Promise.all(topNavigationPromises);
}
